import { FC } from "react"
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { useDeleteCase } from "@/hooks/useDeleteCase"

interface DeleteCaseDialogProps {
    caseId: string
    caseName: string
    isOpen: boolean
    onClose: () => void
}

export const DeleteCaseDialog: FC<DeleteCaseDialogProps> = ({
    caseId,
    caseName,
    isOpen,
    onClose,
}) => {
    const { mutate: deleteCase, isPending } = useDeleteCase(caseId)

    const handleDelete = () => {
        deleteCase(caseId)
        onClose()
    }

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Case</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete the case "{caseName}" and all its associated documents? This action cannot be undone.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={onClose}
                        disabled={isPending}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleDelete}
                        disabled={isPending}
                    >
                        {isPending ? "Deleting..." : "Delete"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
} 